import { useState, useEffect,useCallback } from "react";
// import "./styles/PanelPortafolio.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import LoadSimple from "../LoadSimple";

import ModalCreateException from "./Maintenance/ModalCreateException";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import MaintenanceWrapper from "./Maintenance/MaintenanceWrapper";
import ModalCloseEvent from "./Maintenance/ModalCloseEvent";
import ModalAddHost from "./Maintenance/ModalAddHost";
// import Modal from "react-modal";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const deleteUserModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'35%',
      height:'30%',
      padding:'20px'
    },
  };
  const addHostModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'80%',
      height:'70%',
      padding:'20px'
    },
  };
const PanelProvCalendario = ({ handleShowPopup,server,setInternalError,languaje,mode }) => {
  const limitList = 200;
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
//   var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [exceptions, setExceptions] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;

  const [searchResult, setSearchResult] = useState(null);

  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataMantto, setDataMantto] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [loadingHost, setLoadingHost] = useState(false);
  const [loadingGrupos, setLoadingGrupos] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [ events, setEvents] = useState([]);  //objeto para guardar los eventos de mantenimiento  mostrar en calendario
const [ loadingEvents, setLoadingEvents] = useState(true);
  const [hosts, setHosts] = useState([]); //catalogo host
    const [groups, setGroups] = useState([]); //catalogo grupos
    const [users, setUsers] = useState([]); //catalogo usuario
    const [poolRows,setPoolRows]=useState([])
//   console.log(loadingHost,loadingGrupos,loadingUsers);
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  const fetchEvents = useCallback(async () => {
    try{
        setLoadingEvents(true)
        const response = await fetch(server.url+'/api/v1/cassia/provisioning_events/')
        const data = await response.json();
        // console.log(data)/
        //asegurar el formato de hora esperado en los eventos 2024-11-10 04:00
        const formattedEvents = data.data.map((event) => ({
            ...event,
            start: event.start_time.replace('T', ' ').slice(0, 16),
            end: event.start_time.replace('T', ' ').slice(0, 16),
            title: event.name
        }));
        setEvents(formattedEvents) //guardar eventos obtenidos en objeto events
        // console.log("eventos cargados y formateados:", formattedEvents)
    }catch{
        // console.log('Error al obtener los eventos')
    }finally{
        setLoadingEvents(false); //Terminar de mostrar el loader
    }
},[]);


useEffect(() => {
    fetchEvents(); //cargar eventos al montar
}, [fetchEvents]);
//   useEffect(() => {
//     setPageActual(1);
//   }, [dataList]);
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    setCreateCisModalOpen(true);
  };
  function closCreateManttoModal() {
    setPoolRows([])
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const handleChangEdit = (cis) => {
    // console.log("handle edit");
    setEditActive(true);
    // console.log(cis);
    setDataMantto(cis);
          setCreateCisModalOpen(true);
  };
 
  const regresar_cis = () => {
    setCisSelected([]);
    // setLoadingCis(true)
  };

 
  

  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  function openDeleteUserModal() {
      
    //   console.log('open')
      setDeleteUserModalOpen(true);
    }
  
    function closDeleteUserModal() {
      setDeleteUserModalOpen(false);
    }
    const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }
  
    function closeAddHostModal() {
        setAddHostModalOpen(false);
    }
  return (
    <>
     <div className="head-cis movil-mini" style={{height:'10%'}}>
        <div className="title-cis">
        {/* <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={dataUsers.data}
                    setDataObject={setDataUsers}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  /> */}
          <div className={"cont-result-registers"+mode}>
         
                  {/* <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p>  */}
          </div>
          <div className="cont-buttons-panel">
                  {(loadingHost || loadingEvents)?'':
                  <Action
                  disabled={false}
                  origen="Azul"
                  titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                  action={crear}
                />
                  }
                    
                  
                 
                </div>
        </div>
      </div>
      <div className="cont-cis movil-mini" style={{height:'90%'}}>
      <>
      <div className="main-panel-portafolio">
      <div className="compact-content-portafolio">
                        {
                            (loadingHost || loadingEvents)?<div className="cont-load-user-list">
                            <LoadSimple></LoadSimple>
                          </div>:
                          <MaintenanceWrapper handleChangEdit={handleChangEdit} events={events} loading={loadingEvents} languaje={languaje} mode={mode} server={server} hosts={hosts} groups={groups} users={users}/>
                        }
                      {/* <MaintenanceWrapper server={server}/> */}
        
        </div>
      </div>
    <Modal
    isOpen={CreateCisModalOpen}
    // isOpen={false}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closCreateManttoModal}
    style={CreateCisModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
        <ModalCreateException
      devices={devices}
      server={server}
      editActive={editActive}
      setEditActive={setEditActive}
      dataMantto={dataMantto}
      setData={setData}
      loading={loading}
      setLoading={setLoading}
      setError={setError}
      setRegisterIsValid={setRegisterIsValid}
      closCreateManttoModal={closCreateManttoModal}
      languaje={languaje}
      mode={mode}
      hosts={hosts}
      setHosts={setHosts}
      fetchEvents={fetchEvents}
      openDeleteUserModal={openDeleteUserModal}
      handleShowPopup={handleShowPopup}
      openAddHostModal={openAddHostModal}
      poolRows={poolRows}
      setPoolRows={setPoolRows}
    ></ModalCreateException>
    </Modal>
    <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalCloseEvent  handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} closCreateManttoModal={closCreateManttoModal} fetchEvents={fetchEvents} server={server} setData={setData} setLoading={setLoading} setError={setError} user={dataMantto} closDeleteUserModal={closDeleteUserModal}></ModalCloseEvent>
    </Modal>
    <Modal
        isOpen={addHostModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeAddHostModal}
        style={addHostModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalAddHost poolRows={poolRows}setPoolRows={setPoolRows} languaje={languaje} hosts={hosts}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalAddHost>
    </Modal>
    </>
      </div>
    </>
      
  );
};

export default PanelProvCalendario;
